import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WBComponent } from './wb.component';

import { TechCheckComponent } from '../tech-check/tech-check.component';

import { PlayerComponent } from './player/player.component';
import { NotReadyRoomComponent } from './not-ready-room.component';
import { FullRoomComponent } from './full-room.compoenent';
const routes: Routes = [
    { path: "check/:hash", component: TechCheckComponent },
    { path: "wb/:hash", component: WBComponent },
    { path: "full/:userHash", component: FullRoomComponent },
    { path: "notready/:userHash/:time", component: NotReadyRoomComponent },

    { path: "recorder/:hash/:private", component: WBComponent },
  { path: "wbmobile/:hash/:mobile", component: WBComponent },
    { path: "demo/:demoHash", component: WBComponent },

   
    { path: "player/:hash/:recordContainerId", component: PlayerComponent },
    { path: "content/:containerHash", component: PlayerComponent }

];

export const wbRouting: ModuleWithProviders = RouterModule.forChild(routes); 


// WEBPACK FOOTER //
// /app/src/app/wb/wb.routing.ts